import { SvgIcon } from '@mui/material';
import React from 'react';

interface GoogleIconProps {
  style?: React.CSSProperties;
}

export const GoogleIcon = ({ style = {}, ...props }: GoogleIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 15 15" style={{ width: `15px`, height: `15px`, ...style }}>
      <g id="Google">
        <path
          id="Fill-1"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M3.91384 7.41981C3.91384 6.98371 3.99101 6.56562 4.12873 6.17347L1.71812 4.44556C1.24831 5.34095 0.983612 6.34986 0.983612 7.41981C0.983612 8.48885 1.24798 9.49715 1.71715 10.3919L4.12645 8.66066C3.99003 8.27034 3.91384 7.85377 3.91384 7.41981Z"
          fill="#FBBC05"
        />
        <path
          id="Fill-2"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.1464 3.4524C9.1557 3.4524 10.0673 3.7881 10.7836 4.33742L12.8673 2.38428C11.5976 1.34668 9.96966 0.705811 8.1464 0.705811C5.3158 0.705811 2.88305 2.22529 1.71812 4.44545L4.12873 6.17336C4.68417 4.59072 6.26747 3.4524 8.1464 3.4524Z"
          fill="#EA4335"
        />
        <path
          id="Fill-3"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M8.1464 11.387C6.26747 11.387 4.68417 10.2487 4.12873 8.66602L1.71812 10.3936C2.88305 12.6141 5.3158 14.1336 8.1464 14.1336C9.89347 14.1336 11.5614 13.5513 12.8133 12.4603L10.5251 10.7998C9.87947 11.1816 9.0665 11.387 8.1464 11.387Z"
          fill="#34A853"
        />
        <path
          id="Fill-4"
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.9836 7.41968C14.9836 7.02295 14.9185 6.5957 14.8208 6.19897H8.1464V8.79298H11.9883C11.7962 9.67738 11.2733 10.3573 10.5251 10.7998L12.8133 12.4603C14.1283 11.3147 14.9836 9.60811 14.9836 7.41968Z"
          fill="#4285F4"
        />
      </g>
    </SvgIcon>
  );
};
